module.exports = __webpack_public_path__ + "static/img/FLASH_EXPRESS.0b5b4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/carriers/FLASH_EXPRESS.png
// module id = BT0j
// module chunks = 150